/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import dayjs from 'dayjs';
import type { ComponentChild } from 'preact';

// Core
import useContext, { ClientContext } from '@/client/context';
import useHeader from '@client/pages/useHeader';
import { Input, Popover, Button, Link } from '@client/components';

/*----------------------------------
- TYPES
----------------------------------*/

export type Props = { 
    header?: ComponentChild | ComponentChild[],
    sidebar?: ComponentChild | ComponentChild[],
    children?: ComponentChild | ComponentChild[],
    cover?: ComponentChild | ComponentChild[],
    hideNav?: boolean,
    title: string,
    description: string,
    class?: string,
}

/*----------------------------------
- COMPONENT 
----------------------------------*/
export default ({ 
    header: pageHeader, children,
    hideNav,
    cover,
    title, description, 
    class: className 
}: Props) => {

    /*----------------------------------
    - INIT
    ----------------------------------*/

    const { data, context } = useContext();

    useHeader({ title, description });

    /*----------------------------------
    - ACTIONS
    ----------------------------------*/

    /*----------------------------------
    - RENDER
    ----------------------------------*/
    return <>
        <div id="contPage" class="col col-1" onMouseDown={() => {
            context.setOpenMenu(false);
        }}>

            <aside class="col sp-0">

                <div class="row">

                    <Button icon="bars" shape="pill" class="Mobile" type="secondary"
                        onClick={() => {
                            context.setOpenMenu(true);
                        }}
                    />

                    <div class="row al-center col-1">

                        <Input title="Search" wrapper={false} icon="search" className='Desktop' 
                            onClick={() => {
                                console.log('clicked');
                            }} />

                        <Link title="Unique Domains" to="/" id="Logo" class="Mobile">
                            unique<strong class="fg primary">.</strong>
                        </Link>
                    </div>

                    <div class="row">
                        <Button type="primary" shape="pill" link="/" iconR="long-arrow-right">
                            Domains
                        </Button>
                    </div>
                </div>

                {!hideNav && (
                    <nav>
                        <ul class="row menu scrollable sp-05">
                            {data.navigation.topics.slice(0, 6).map((topic, i) => (
                                <li>
                                    <Button link={`/blog/topic/${topic.slug}`} size="s">
                                        {topic.name}
                                    </Button>
                                </li>
                            ))}
                        </ul>
                    </nav>
                )}

                {/* <div class="row al-center badge pdv-05 pdh-1">
                    <div>
                        Are you looking for unique domain names?
                    </div>
                    <div class="row sp-05">
                        <Button link="/" target="_blank" size="xs">
                            Yes
                        </Button>
                        <Button size="xs">
                            No
                        </Button>
                    </div>
                </div> */}
            </aside>

            {pageHeader}

            {cover}

            <main id="page" class={className || "col sp-0 col-1"}>
                {children}
            </main>
        </div>

        {/* <aside id="rightBar" class="col">

            <div class="col sp-0 scrollable col-1 pdh-2 sep-1">
                {sidebar}
            </div>

            <div class="col al-center l pdh-2 pdv-3 bt-1">

                <div>
                    Find the domain name that will drive your business growth
                </div>

                <Button type="primary" link="/" target="_blank" shape="pill">
                    Start for free
                </Button>
                
            </div>

        </aside> */}
    </>
}